export default "__VITE_ASSET__B9xyWC5u__"